<dialog
  #dialog
  qai-dialog
  [heading]="title"
  [description]="''"
  [showClose]="false"
>
  <div class="camera-warning-content">
    <div class="warning-icon">
      <qai-icon kind="alert-triangle" size="48px"></qai-icon>
    </div>
    <p class="warning-text">{{ warningText }}</p>
    <p class="instruction">{{ instructionText }}</p>
  </div>
</dialog>
